module.exports = __webpack_public_path__ + "src/images/cpp-logo.614e81bd92afc62be8127beac5e1b9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cpp-logo.png
// module id = 99
// module chunks = 0